export default __webpack_public_path__ + "static/media/dollarSign.6166e90d.svg";